/* eslint-disable react/prop-types */
import React from 'react';
import { Slider } from '@fiverr-private/orca';
import { PortraitTile } from '../../PortraitTile';
import './styles.scss';

export const Carousel = ({ items, small }) => {
    if (!items?.length) {
        return null;
    }
    const breakpoints = small
        ? [
              {
                  breakpoint: 799,
                  slides: 2,
                  slidesToScroll: 2,
              },
              {
                  breakpoint: 599,
                  slides: 1,
                  slidesToScroll: 1,
              },
          ]
        : Slider.SLIDER_BREAKPOINTS.map((breakpoint) => ({ ...breakpoint, slidesToScroll: breakpoint.slides }));

    return (
        <div className="carousel-list-view">
            <Slider
                items={items}
                className="careers-carousel"
                Component={PortraitTile}
                smallArrows
                slidesToShow={small ? 2 : 4}
                sliderBreakpoints={breakpoints}
                useArrows={true}
            />
        </div>
    );
};
